import React from 'react'
import { Text } from '@quotatisgroup/uikit-public.ui.text'
import { Row } from '@quotatisgroup/uikit-public.ui.row'
import { Col } from '@quotatisgroup/uikit-public.ui.col'
import { Button } from '@quotatisgroup/uikit-public.ui.button'
import UniverseLink from 'components/UniverseLink/UniverseLinkContainer'
import { Title } from '@quotatisgroup/uikit-public.ui.title'
import { Image } from '@quotatisgroup/uikit-public.ui.image'
import { StickyBar } from '@quotatisgroup/uikit-public.ui.sticky-bar'
import { Modal } from '@quotatisgroup/uikit-public.ui.modal'
import injectTranslate from 'i18n/hoc/injectTranslate'
import PropTypes from 'prop-types'
import { useMediaQuery } from 'react-responsive'
import cloudinary from 'utils/cloudinary'

const MOBILE_WIDTH_BREAKPOINT = 1224

const StepToBecomeProBlock = ({ translate }) => {
  const isTabletOrMobile = useMediaQuery({
    query: `(max-width: ${MOBILE_WIDTH_BREAKPOINT}px)`,
  })
  if (!isTabletOrMobile) {
    return null
  }

  const startButton = (
    <UniverseLink id="pro-popin-link" href="/inscription-artisan-poseur">
      <Button id="pro-popin" size="xs" variant="primary" margin="top-xs">
        {translate('propage.popin.button')}
      </Button>
    </UniverseLink>
  )

  return (
    <StickyBar scrollPositionBreakpoint={-1}>
      <Row hasVerticalAlign>
        <Col md="6">
          <Title headingLevel="6" isBold margin="bottom-xs" size="small">
            {translate('propage.popin.text1')}
          </Title>
          <Title headingLevel="6" margin="top-xs" size="small">
            {translate('propage.popin.text2')}
          </Title>
        </Col>
        <Col md="1" marginHorizontalAuto>
          <Modal
            trigger={
              <Image
                src={cloudinary('/icons/info.png')}
                alt={translate('alt.home.stars')}
                padding="vertical-sm"
                width="18"
              />
            }
          >
            <Title headingLevel="3">{translate('propage.popin.title')}</Title>
            <Text isBold margin="bottom-xs">
              {translate('propage.popin.sub1.title')}
            </Text>
            <Text color="grey" margin="top-xs">
              {translate('propage.popin.sub1.text')}
            </Text>
            <Text isBold margin="bottom-xs">
              {translate('propage.popin.sub2.title')}
            </Text>
            <Text color="grey" margin="top-xs">
              {translate('propage.popin.sub2.text')}
            </Text>
            <Text isBold margin="bottom-xs">
              {translate('propage.popin.sub3.title')}
            </Text>
            <Text color="grey" margin="top-xs">
              {translate('propage.popin.sub3.text')}
            </Text>
            <Text isBold margin="bottom-xs">
              {translate('propage.popin.sub4.title')}
            </Text>
            <Text color="grey" margin="top-xs">
              {translate('propage.popin.sub4.text')}
            </Text>
            <Text isBold margin="bottom-xs">
              {translate('propage.popin.sub5.title')}
            </Text>
            <Text color="grey" margin="top-xs">
              {translate('propage.popin.sub5.text')}
            </Text>
            {startButton}
          </Modal>
        </Col>
        <Col md="5">{startButton}</Col>
      </Row>
    </StickyBar>
  )
}

StepToBecomeProBlock.propTypes = {
  translate: PropTypes.func,
}

export default injectTranslate(StepToBecomeProBlock)
